import * as React from 'react';

import thematize from 'lib/thematize';
import styles from './Empty.scss';

const theme = thematize(styles);

interface Props {
  message: string | React.ReactElement;
}

const Empty = ({ message }: Props): React.ReactElement => (
  <div className={theme('empty')}>{message}</div>
);

export default Empty;
